<template>
  <el-card class="box-card mb-50 box-search" id="transactionList">
    <span class="tilte-search mb-10">{{ $t('transactions.index.search_title') }}</span>
    <el-form ref="dataSearch" :model="dataSearch" @submit.prevent="search" class="form-search-transaction">
      <el-form-item prop="text" class="input-size-454">
        <el-input :placeholder="$t('transactions.index.search_input_placeholder')" v-model="dataSearch.filters[3].data"/>
      </el-form-item>
      <el-form-item prop="transaction_date" class="full-width">
        <label slot="label" class="label-field-search full-width">{{ $t('transactions.index.transaction_date') }}</label>
        <date-form
          @change-date="changeDate"
          :date="dataSearch.filters[0].data"
          :key="dataSearch.filters[0].data"
          :yearPlaceHolder="this.$t('year')"
          :listYear="listYear"
        >
        </date-form>
      </el-form-item>
      <el-form-item prop="type" v-if="site != $siteType.site_partner">
        <label slot="label" class="label-field-search full-width text-left font-weight-700">
          {{ $t('transactions.index.search_detail') }}
        </label> <br>
        <el-checkbox-group v-model="dataSearch.filters[1].data" class="checkbox-search">
          <el-checkbox :label="transactionTypes.charge" :key="transactionTypes.charge">
            {{ $t('transactions.index.type.charge') }}
          </el-checkbox>
          <el-checkbox :label="transactionTypes.receipt" :key="transactionTypes.receipt" :checked="true">
            {{ $t('transactions.index.type.receipt') }}
          </el-checkbox>
        </el-checkbox-group>
        <el-checkbox :label="isCancelled" :checked="true"
          v-model="dataSearch.filters[2].data" class="ml-30">
          {{ $t('transactions.index.cancel') }}
        </el-checkbox>
        <el-checkbox-group v-model="dataSearch.filters[1].data" class="checkbox-search">
          <el-checkbox :label="transactionTypes.present" :key="transactionTypes.present" :checked="true" class="ml-30">
            {{ $t('transactions.index.type.present') }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item>
        <el-button type="danger" class="btn-search" @click="search" @keyup.enter.native="search">{{ $t('btn_search') }}</el-button>
        <el-button type="info" class="btn-clear" @click="resetForm">{{ $t('btn_clear') }}</el-button>
      </el-form-item>
    </el-form>
    <table-data :data="data" :loading="loading" :columns="columns" :links="links" :showIndex="false"
      @change-page="handleChangePage" @click-link="handleClickLinkTable"
      @sort="sort">
    </table-data>
  </el-card>
</template>
<script>
  import { getListData } from '../../api/transaction'
  import { IS_CANCELLED, TRANSACTION_TYPE, YEARS_START_FROM_2022 } from '../../constants'

  export default {
    props: {
      site: { type: Number, required: false },
    },

    data() {
      return {
        listQuery: {
          page: 1,
          text: "",
          filters: [
            { 'key': 'transaction_datetime', 'data': { year: '', month: '', day: '' } },
            { 'key': 'types', 'data': [TRANSACTION_TYPE['receipt'], TRANSACTION_TYPE['present']] },
            { 'key': 'is_cancelled', 'data': IS_CANCELLED },
            { 'key': 'p_id', 'data': '' },
          ]
        },
        data: {},
        loading: true,
        columns: [
          { prop: "p_id", label: "取引コード", sortable: false, class: "" },
          { prop: "transaction_datetime", label: "日付", sortable: "custom", class: "" },
          { prop: "time", label: "時間", sortable: false, class: "" },
          { prop: "detail", label: "詳細", sortable: false,  class: "", width: "400" }
        ],
        links: [
          { id: "1", label: "詳細", type: "detail", class: "link-detail" }
        ],
        sortProp: {key: 'transaction_datetime', dir: 'descending'},
        transactionTypes: TRANSACTION_TYPE,
        isCancelled: IS_CANCELLED,
        listYear: YEARS_START_FROM_2022,
        dataSearch: {
          page: 1,
          text: "",
          filters: [
            { 'key': 'transaction_datetime', 'data': { year: '', month: '', day: '' } },
            { 'key': 'types', 'data': [TRANSACTION_TYPE['receipt'], TRANSACTION_TYPE['present']] },
            { 'key': 'is_cancelled', 'data': IS_CANCELLED },
            { 'key': 'p_id', 'data': '' },
          ]
        },
      }
    },

    methods: {
      getListData() {
        const query = {...this.listQuery, ...this.sortProp};
        query.filters = JSON.stringify(this.listQuery.filters);

        getListData(query)
        .then(response => response.json())
        .then(response => {
          response.data.records = response.data.records.map(e => {
            return {
              ...e,
              detail: this.formatTextDetail(e.detail, e.is_cancelled),
              point: this.formatPoint(e.point)
            }
          });
          this.data = response.data;
          this.loading = false;
        })
        .catch((error) => {})
        .finally(() => {});
      },

      handleChangePage(page) {
        this.loading = true;
        this.listQuery.page = page;
        this.getListData();
      },

      search() {
        this.loading = true;
        this.listQuery = Object.fromEntries(Object.entries(this.dataSearch).map(([k, v]) => [k, v]));
        this.listQuery.page = 1;
        this.getListData();
      },

      handleClickLinkTable(type, row) {
        window.location.href = "/transactions/"+row.id;
      },

      sort(sortProps) {
        this.sortProp = {key: sortProps.prop, dir: sortProps.order};
        this.listQuery.page = 1;
        this.getListData();
      },

      resetForm() {
        this.$refs["dataSearch"].resetFields();
        this.dataSearch.filters[0].data = { year: '', month: '', day: '' };
        this.dataSearch.filters[1].data = [this.transactionTypes.receipt, this.transactionTypes.present];
        this.dataSearch.filters[2].data = this.isCancelled;
        this.dataSearch.filters[3].data = '';
      },

      changeDate(data) {
        this.listQuery.filters[0].data = data;
      },

      formatTextDetail(detail, isCancelled) {
        if (isCancelled) {
          return `<span class="is-cancelled">${ this.$t('transactions.is_cancelled') }</span>${ detail }`;
        }

        return detail;
      },

      formatPoint(point) {
        return `<span class="text-point">+${point}</span>`;
      }
    },

    created() {
      if (this.site == this.$siteType.site_partner) {
        this.columns = [
          { prop: "p_id", label: "取引コード", sortable: false, class: "" },
          { prop: "transaction_datetime", label: "日付", sortable: "custom", class: "" },
          { prop: "time", label: "時間", sortable: false, class: "" },
          { prop: "detail", label: "詳細", sortable: false,  class: "", width: "500" },
          { prop: "point", label: "ココロン", sortable: false,  class: "text-right" }
        ]
      }
      this.getListData();
    },
  }
</script>

<style lang="scss">
  .form-search-transaction {
    .el-checkbox {
      --el-checkbox-checked-bg-color: #AC3B29;
      --el-checkbox-input-border-color-hover: #AC3B29;
      --el-checkbox-checked-icon-color: #FFFF;
      --el-checkbox-checked-input-border-color: #AC3B29;
      --el-checkbox-font-size: 11px;
    }
    .date-form {
      .input-datetime {
        margin-left: 20px;
        width: 100% !important;
        .el-input {
          width: 90px;
          height: 45px;
          --el-select-input-focus-border-color: #c0c4cc;
          .el-input__wrapper {
            border-radius: 0;
          }
        }
      }
      .year-input {
        .input-datetime {
          margin-left: 0px;
          .el-input {
            width: 120px;
          }
        }
      }
    }
  }
  #transactionList {
    .el-form {
      width: 100%;
      .el-checkbox__label {
        letter-spacing: 1.3px;
      }
    }
    .text-point {
      text-align: right;
      font: normal normal normal 11px/29px Kozuka Gothic Pr6N;
      letter-spacing: 1.3px;
      color: #468349;
    }
    .el-card__body {
      &>hr {
        margin: 20px 0;
      }
    }
    .label-field-search {
      line-height: 1;
      display: block;
      margin-bottom: 10px;
      letter-spacing: 1.3px;
    }
  }
</style>
